/**
 * Create Cart context for custom hook
 */
import { createContext } from 'react'

const UserPreferencesContext = createContext({
  userPreferences: {},
  setUserPreferences: () => {},
})

export default UserPreferencesContext
